import type { UserOrganizationHeaderAlertProps } from "./user-organization-header-alert.type";

import { PlusOutlined } from "@ant-design/icons";
import { Button, Alert } from "antd";
import { useTranslation } from "react-i18next";

import UserEdit from "@/features/Users/UserEdit";
import { useSidePanel } from "@/modules/side-panel";

import "./user-organization-header-alert.style.less";

export const UserOrganizationHeaderAlert = ({
  user,
}: UserOrganizationHeaderAlertProps) => {
  const { t } = useTranslation();
  const { openSidePanel } = useSidePanel();

  const handleClick = () => {
    openSidePanel({
      title: user.name,
      component: <UserEdit userId={user.id} />,
    });
  };

  return (
    <Alert
      type="error"
      showIcon
      title={t(`user:organizationRole.noRole.label`, {
        organization: user.organization?.name,
      })}
      description={t(`user:organizationRole.noRole.description`)}
      action={
        <Button icon={<PlusOutlined />} onClick={handleClick}>
          {t("global:add")} {t("user:role")}
        </Button>
      }
      className="user-organization-header-alert"
    />
  );
};
